import React from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Home from "../pages/inicio";
import Contact from "../pages/contact";
import Solutions from "../pages/solutions";
import About from "../pages/about";

function AnimatedRoutes() {
  const location = useLocation();
  const nodeRef = React.useRef(null);

  return (
    <SwitchTransition>
      <CSSTransition
        key={location.pathname}
        classNames="fade"
        timeout={180}
        nodeRef={nodeRef}
      >
        <div ref={nodeRef}>
          <Routes location={location}>
            <Route path="/" element={<Home/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/solutions" element={<Solutions/>} />
            <Route path="/about" element={<About/>} />
            
            {/* Agrega aquí más rutas según sea necesario */}
          </Routes>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}

export default AnimatedRoutes;
